import React from "react";
import { Table, Button, message } from "antd";
import { getChargeRecord } from "@/api/invoice";
import Storage from "@/utils/storage";
import "./style.less";
import { formatRecord } from "@/utils/format";

const clsPrefix = "charge-record-table";

const recordTableColumns = [
  {
    title: "产品名称",
    dataIndex: "goodsName"
  },
  {
    title: "订单id",
    dataIndex: "orderId"
  },
  {
    title: "充值日期",
    dataIndex: "payExpire"
  },
  {
    title: "金额",
    dataIndex: "money"
  },
  {
    title: "已开票",
    dataIndex: "invoicedStatus"
  }
];

class TableRecord extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedRowKeys: [],
      loading: false,
      // 获取的数据
      chargeRecord: [],
      // 分页
      offset: 0,
      current: 1,
      total: 0
    };
  }
  getChargeDataAndRender = () => {
    getChargeRecord(this.state.offset)
      .then(res => {
        this.setState({ total: res.count });
        return res.paymentOrderList.map(record => formatRecord(record));
      })
      .then(data => {
        const addedKeyChargeRecord = data.map((item, index) => ({
          key: index + 1 + this.state.offset,
          ...item
        }));
        this.setState({
          chargeRecord: addedKeyChargeRecord
        });
      })
      .catch(err => {
        console.log(err);
      });
  };
  componentDidMount = () => {
    this.getChargeDataAndRender();
  };
  // 分页的实现
  changePage = page => {
    this.setState(
      {
        current: page
      },
      () => {
        this.setState(
          {
            offset: (this.state.current - 1) * 10
          },
          () => {
            this.getChargeDataAndRender();
          }
        );
      }
    );
  };

  confimInvoice = () => {
    let selectedIdArr = this.state.selectedRowKeys;
    if (selectedIdArr.length > 0) {
      let arr = [];
      selectedIdArr.forEach((item) => {
        arr.push(this.state.chargeRecord[item - 1]);
      });
      Storage.invoiceList.set(arr);
      window.location.href = "/v5/invoice/invoiceTitle";
    } else {
      this.warning();
      return false;
    }
  };

  warning = () => {
    message.warning("请选择要开具的发票！");
  };

  start = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({
        selectedRowKeys: [],
        loading: false
      });
    }, 1000);
  };

  onSelectChange = selectedRowKeys => {
    this.setState({ selectedRowKeys });
  };

  render() {
    const { selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      getCheckboxProps: record => ({
        disabled: record.invoicedStatus === "是"
      })
    };
    const hasSelected = selectedRowKeys.length > 0;
    return (
      <div className={clsPrefix}>
        <div className="tableTop">
          <span className="tableText">
            {hasSelected ? `选择了 ${selectedRowKeys.length} 项` : ""}
          </span>
        </div>
        <Table
          className="tableBox"
          rowSelection={rowSelection}
          columns={recordTableColumns}
          dataSource={this.state.chargeRecord}
          pagination={{
            pageSize: 10,
            current: this.state.current,
            onChange: this.changePage,
            total: this.state.total
          }}
        />
        <Button className="antBtn" type="primary" onClick={this.confimInvoice}>
          确认开具发票
        </Button>
      </div>
    );
  }
}
export default TableRecord;
